export type AgendaAttributeValue = string | number | boolean | Record<string, string>[];

type TableDisplayValue = { text?: string; email?: string; phoneNumber?: string; number?: string; reference?: string };

export interface DisplayValue {
  id: string;
  value: string | string[] | TableDisplayValue[];
}

export const isDisplayValue = (item: unknown): item is DisplayValue => {
  if (typeof item !== 'object' || item === null) {
    return false;
  }

  const keys = Object.keys(item);
  if (keys.length !== 2 || !keys.includes('id') || !keys.includes('value')) {
    return false;
  }

  if (!('id' in item) || typeof item.id !== 'string') {
    return false;
  }

  if (!('value' in item)) {
    return false;
  }

  const { value } = item;

  if (typeof value === 'string') {
    return true;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return true;
    }

    const allStrings = value.every((arrayItem) => typeof arrayItem === 'string');
    if (allStrings) {
      return true;
    }

    const allTableDisplayValues = value.every(
      (arrayItem) =>
        typeof arrayItem === 'object' &&
        arrayItem !== null &&
        Object.keys(arrayItem).every((key) => ['text', 'email', 'phoneNumber', 'number', 'reference'].includes(key)) &&
        Object.values(arrayItem).every((val) => typeof val === 'string' || val === undefined)
    );

    return allTableDisplayValues;
  }

  return false;
};
